import { JSXElement, lazy } from 'solid-js';
import { getSlug, HandlersPath } from '~/components/AppRouter/utils.ts';
import { Route } from '@solidjs/router';

const TestSSOHandler = lazy(
  () => import('~/pages/Handlers/TestSSOHandler.tsx')
);

const DirectoryCallbackHandler = lazy(
  () => import('~/pages/Handlers/DirectoryCallbackHandler.tsx')
);

const CrossBrowserAuthFailure = lazy(
  () => import('~/pages/Handlers/CrossBrowserAuthFailure.tsx')
);

const LoginCallbackHandler = lazy(
  () => import('~/pages/Handlers/AuthCallback.tsx')
);

const ConnectAuthSuccess = lazy(
  () => import('~/pages/ScalekitConnect/handlers/AuthSuccess')
);

export default function UiHandlerRoutes(): JSXElement {
  return (
    <Route path={getSlug.getHandlersBaseNamespace()}>
      <Route
        path={getSlug.handlers(HandlersPath.TEST_SSO)}
        component={TestSSOHandler}
      />
      <Route
        path={getSlug.handlers(HandlersPath.LOGIN_CALLBACK)}
        component={LoginCallbackHandler}
      />
      <Route
        path={getSlug.handlers(HandlersPath.DIRECTORY_SYNC_CALLBACK)}
        component={DirectoryCallbackHandler}
      />
      <Route
        path={getSlug.handlers(HandlersPath.CROSS_BROWSER_AUTH_FAILURE)}
        component={CrossBrowserAuthFailure}
      />
      <Route
        path={getSlug.handlers(HandlersPath.CONNECT_AUTH_SUCCESS)}
        component={ConnectAuthSuccess}
      />
    </Route>
  );
}
